export const Constants = {
		maxMapZoom: 15,
		mapCenterLat: 25.761681, //this is for miami
		mapCenterLng: -80.191788,
		userDistanceKilometersThreshold: 250,
}
